import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { useLocale } from '../../../contexts/localeContext';
import CredentialDateInfo from '../credential-date-info';
import GenerateQRCode from './generate-qrcode';

interface Props {
    taskDescription: string;
    onBack: (event: any) => void;
    isEdit: boolean,
    cardCode: string,
    setImage: (base64Img: string) => void,
    downloadQRCode: () => void
}

const SummaryForm: FC<Props> = ({ taskDescription, onBack, isEdit, cardCode, setImage, downloadQRCode }) => {

    const { values } = useFormikContext<any>();
    const { translate } = useLocale();

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div>
            <div>
                {!isEdit ?
                    <div className="flex flex-row">
                        <div className="flex flex-col flex-1">
                            <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
                            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.task)}: <span className="text-sm text-black">{taskDescription}</span></h4>
                        </div>
                    </div> : null
                }
                <div className="flex pt-3">
                    <div className="flex flex-col flex-1 w-50">
                        <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
                        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.tagCode)}: <span className="text-sm text-black">{values.code}</span></h4>
                        <CredentialDateInfo values={values} />
                    </div>
                </div>
            </div>
            <GenerateQRCode
                cardCode={cardCode}
                setImage={setImage}
            />
        </div>

        <div className="flex justify-between w-full absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row">
                <button
                    className={`py-1 px-4 mr-2 mt-3 rounded-full text-white bg-sidemenu-focus text-sm items-center`}
                    type="button"
                    onClick={() => { downloadQRCode() }}>{translate.byKey(TranslationKeys.download)}</button>
            </div>
            <div className="flex mt-4">
                <button
                    className={`secondary secondary-inverse mr-2 py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="submit">{translate.byKey(TranslationKeys.confirm)}</button>
            </div>

        </div>
    </div>
}

export default SummaryForm;
